import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { setOpenSnackBar } from '../redux/siteAuditReducer';
import { snackBarErrorText } from './config/TextMessage';

export const CommonSnackBar = ({ open = false }: { open: any }) => {
  const dispatch = useDispatch();
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState<'error' | 'success' | 'warning' | 'info'>('error');

  useEffect(() => {
    if (open) {
      if (typeof open === 'object' && open !== null) {
        setMessage(open.message || "Something went wrong. Please try again later11.");
        setSeverity(open.type || 'error');
      } else {
        setMessage(snackBarErrorText);
        setSeverity('error');
      }
      setSnackBarOpen(true);
    } else {
      setSnackBarOpen(false);
    }
  }, [open]);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackBarOpen(false);
    dispatch(setOpenSnackBar(false));
  };

  return (
    <Fragment>
      <Snackbar
        sx={{ marginTop: '0.5rem' }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={snackBarOpen}
        autoHideDuration={4000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={severity}
          sx={{
            width: '100%',
            maxWidth: '610px',
            backgroundColor: severity === 'success' ? 'green' : 'red',
            color: 'white',
            '.MuiAlert-message': {
              wordBreak: 'break-all',
              whiteSpace: 'pre-wrap'
            },
            '.MuiAlert-icon': {
              color: 'white'
            }
          }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Fragment>
  );
};
